// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".day[data-v-5479160e]{font-weight:900}.chechbox .v-input__slot[data-v-5479160e]{margin:0!important}.checkbox-dense-margin-top[data-v-5479160e]{margin-top:0}", ""]);
// Exports
module.exports = exports;
